<template>
  <v-content>
    <v-card>
      <v-layout class="text-field-add-account">
        <v-flex xs10 mt-8>
          <v-form ref="form" v-model="valid" lazy-validation>

            <v-layout justify-center>
              <v-flex xs4 sm3 md2 mr-4 pt-1 style="text-align: right;">
                หน่วยงาน :
              </v-flex>
              <v-flex xs6>
                <v-text-field
                  v-model="form.department"
                  background-color="#E5E5E5"
                  solo
                  flat
                  :rules="[v => !!v || 'Department is required']"
                  label="หน่วยงาน"
                  required
                ></v-text-field>
              </v-flex>
            </v-layout>

            <v-layout justify-center>
              <v-flex xs4 sm3 md2 mr-4 pt-1 style="text-align: right;">
                สังกัด :
              </v-flex>
              <v-flex xs6>
                <v-text-field
                  v-model="form.member"
                  background-color="#E5E5E5"
                  solo
                  flat
                  :rules="[v => !!v || 'Member is required']"
                  label="สังกัด"
                  required
                ></v-text-field>
              </v-flex>
            </v-layout>

            <v-layout justify-center>
              <v-flex xs4 sm3 md2 mr-4 pt-1 style="text-align: right;">
                รหัสหน่วยงาน :
              </v-flex>
              <v-flex xs6>
                <v-text-field
                  v-model="form.noDepartment"
                  background-color="#E5E5E5"
                  solo
                  flat
                  :rules="[v => !!v || 'Number Department is required']"
                  label="รหัสหน่วยงาน"
                  required
                ></v-text-field>
              </v-flex>
            </v-layout>

            <v-layout justify-center>
              <v-flex xs4 sm3 md2 mr-4 pt-1 style="text-align: right;">
                หมายเลขโทรศัพท์ :
              </v-flex>
              <v-flex xs6>
                <v-text-field
                  v-model="form.tel"
                  background-color="#E5E5E5"
                  solo
                  flat
                  :rules="telRules"
                  placeholder="หมายเลขโทรศัพท์"
                  required
                ></v-text-field>
              </v-flex>
            </v-layout>

            <v-layout justify-center>
              <v-flex xs4 sm3 md2 mr-4 pt-1 style="text-align: right;">
                ที่ตั้งหน่วยงาน :
              </v-flex>
              <v-flex xs6>
                <v-textarea
                  v-model="form.locationDepartment"
                  background-color="#E5E5E5"
                  solo
                  flat
                  :rules="locationRules"
                  placeholder="ที่ตั้งหน่วยงาน"
                  required
                ></v-textarea>
              </v-flex>
            </v-layout>

            <v-layout justify-center>
              <v-flex xs4 sm3 md2 mr-4 pt-1 style="text-align: right;">
                จังหวัด :
              </v-flex>
              <v-flex xs6>
                <v-select
                  v-model="form.province"
                  background-color="#E5E5E5"
                  solo
                  flat
                  :items="province"
                  item-text="province_name"
                  item-value="province_code"
                  :value-comparator="findMatchingProvince"
                  @input="getDistricts"
                  :rules="[v => !!v || 'Province is required']"
                  label="จังหวัด"
                  required
                ></v-select>
              </v-flex>
            </v-layout>

            <v-layout justify-center>
              <v-flex xs4 sm3 md2 mr-4 pt-1 style="text-align: right;">
                อำเภอ :
              </v-flex>
              <v-flex xs6>
                <v-select
                  v-model="form.district"
                  background-color="#E5E5E5"
                  solo
                  flat
                  :items="district"
                  item-text="district_name"
                  item-value="district_id"
                  :value-comparator="findMatchingDistrict"
                  :rules="[v => !!v || 'District is required']"
                  label="อำเภอ"
                  required
                ></v-select>
              </v-flex>
            </v-layout>

          </v-form>
        </v-flex>
      </v-layout>
    </v-card>

    <!-- Button -->
    <v-layout>
      <v-flex mt-8 pr-12 style="text-align: right;">

        <v-btn
          color="#BDBDBD"
          class="mr-4"
          @click="$router.push({ path: '/manage-user-accounts', query: { activeTab: 2 } }).catch(err => {})"
        >
          ย้อนกลับ
        </v-btn>

        <v-btn v-if="isEdit==true"
               color="#D97C57"
               class="mr-4"
               @click="deleteDepartment()"
        >
          <span style="color: white;">ลบบัญชี</span>
        </v-btn>

        <v-btn v-if="isAdd==true"
          :disabled="!valid"
          color="#527281"
          class="mr-4"
          @click="saveDepartment()"
        >
          <span style="color: white;">ยืนยันการเพิ่มหน่วย</span>
        </v-btn>

        <v-btn v-if="isEdit==true"
               :disabled="!valid"
               color="#527281"
               class="mr-4"
               @click="editDepartment()"
        >
          <span style="color: white;">ยืนยันการแก้ไขหน่วย</span>
        </v-btn>

      </v-flex>
    </v-layout>

  </v-content>
</template>

<script>
    import validate from "../utils/validate";
    import Service from '../service';

    export default {
        async created() {
            this.getProvinces();
            if (this.$route.params.id) {
                await this.getOrganizationEdit();
                this.getDistricts(this.form.province);
            }
        },
        name: "FormManageDepartment",
        props: {
            isEdit: {
                type: Boolean,
                default: false,
            },
            isAdd: {
                type: Boolean,
                default: false,
            }
        },
        data: () => ({
            valid: true,
            province: [],
            district: [],
            form: {
                department: "",
                member: "",
                noDepartment: "",
                tel: "",
                locationDepartment: "",
                district: "",
                province: "",
            },
            locationRules: [
                v => validate.required(v, "Location Department"),
            ],
            telRules: [
                v => validate.required(v, "Tel.No"),
                v => validate.onlyNumber(v, "please input Tel.no"),
            ]
        }),
        methods: {
            validate() {
                if (this.$refs.form.validate()) {
                    this.snackbar = true
                }
            },

            //Show Province
            getProvinces() {
              Service.Common.getProvince().then(data => {
                  let dataProvinces = data;
                  dataProvinces.forEach(dataProvince => {
                      this.province.push({
                          province_code: `${dataProvince.code}`,
                          province_name: `${dataProvince.name}`,
                          province_id: `${dataProvince.province_id}`,
                      });
                  })
              })
            },
            findMatchingProvince(a,b) {
                return a==b;
            },

            //Get District
            getDistricts(id) {
                if (id) {
                    Service.Common.getDistrict(id).then(data => {
                        // console.log(data)
                        this.district = [];
                        data.forEach(dataDistrict => {
                            this.district.push({
                                district_id: `${dataDistrict.district_id}`,
                                province_id: `${dataDistrict.province_id}`,
                                district_name: `${dataDistrict.name}`,
                            });
                        })
                    })
                }

            },
            findMatchingDistrict(a,b) {
                return a==b;
            },

            async saveDepartment() {
                // console.log(this.$refs.form.validate());
                if(this.$refs.form.validate() == false) {
                    console.log('Error');
                } else {
                    confirm('Do you want to edit Account');
                    let result = await Service.Organization.saveOrganization({
                        name: this.form.department,
                        party: this.form.member,
                        organize: this.form.noDepartment,
                        tel: this.form.tel,
                        address: this.form.locationDepartment,
                        district: this.form.district,
                        province: this.form.province,
                    })
                    // console.log(result)
                    if (result) {
                        alert('Save Success')
                    } else {
                        alert('Save Error')
                    }
                }
            },
            async deleteDepartment() {
                confirm('Do you want to delete Account ID : '+this.$route.params.id);

                let result = await Service.Organization.deleteOrganization(this.$route.params.id)

                if (result) {
                    alert("Delete Success")
                    this.$router.push('/manage-user-accounts').catch(err => {})
                }else {
                    alert("Delete Failed")
                }
            },

            getOrganizationEdit() {
                return Service.Organization.getOrganizationEdit(this.$route.params.id).then(data => {
                    this.form.department = data.name;
                    this.form.member = data.party;
                    this.form.noDepartment = data.organize;
                    this.form.tel = data.tel;
                    this.form.locationDepartment = data.address;
                    this.form.district = data.district;
                    this.form.province = data.province;
                })
            },
            editDepartment() {
                let result = Service.Organization.editOrganization(this.$route.params.id, {
                    name: this.form.department,
                    party: this.form.member,
                    organize: this.form.noDepartment,
                    tel: this.form.tel,
                    address: this.form.locationDepartment,
                    district: this.form.district,
                    province: this.form.province,
                })

                if (result) {
                    alert('Edit Success');
                    // this.$router.push({ path: '/manage-user-accounts', query: { activeTab: 2 } });
                }else {
                    alert('Edit Error...');
                }
            }
        }
    }
</script>

<style lang="scss">
  .text-field-add-account {
    .v-text-field.v-text-field--solo .v-input__control {
      min-height: auto;
      border-radius: 20px;
    }

    .theme--light.v-input:not(.v-input--is-disabled) input, .theme--light.v-input:not(.v-input--is-disabled) textarea {
      color: #527281;
    }

    .theme--light.v-select .v-select__selections {
      color: #527281;
    }
  }
</style>

